enum JobType {
  None = "None",
  Test = "Test",
  ImageDownload = "ImageDownload",
  TagUsers = "TagUsers",
  SyncUsers = "SyncUsers",
  Publish = "Publish",
}

export default JobType;
